import React from 'react';
import Heading from '../components/heading/Heading';
import Header from './../components/header/Header';
import Error from './Error';
// import ScrollToTop from './../components/scroll-top/ScrollTop';
import Footer from './../components/footer/Footer';
// import GoToTop from './../components/go-to-top/GoToTop';
// import FaqBtn from './../components/faq-btn/FaqBtn';
// import ModalFaq from './../components/static-modals/ModalFaq'
// import Cookies from './../components/cookies/Cookies';
import { BrowserRouter as Router, Route, Link } from "react-router";

const ErrorFullApp = () => {

    let checkCookie = () => {
        if (typeof window !== 'undefined') {
            if (localStorage.getItem('cookie') != null) {
                return false;
            } else {
                return true;
            }
        }
    }

    return (
        <div className="App">
            <div className="ghost" />
            <Router>
                <Header />
                {/* <ScrollToTop> */}
                    <Error />
                {/* </ScrollToTop> */}
                {/* < GoToTop /> */}
                {/* <FaqBtn /> */}
                {/* <ModalFaq /> */}
                {/* <Cookies cookieText={`Ta strona wykorzystuje techniczne i funkcjonalne pliki cookies lub internetowe analityczne pliki cookies, za Twoją zgodą marketingowe pliki cookies. Więcej na ten temat przeczytasz w <a id='cookies-link' href='https://newonline.leasingoptymalny.pl/od/?target=polityka-prywatnosci' target='__blank'>Polityce prywatności</a>. Wchodząc na stronę wyrażasz na nie zgodę według ustawień Twojej przeglądarki. Możesz je w każdej chwili zmienić, a jeśli tego nie zrobisz przeglądanie strony nastąpi z wykorzystaniem tych plików.`} visible={ checkCookie() } /> */}
                <Footer />
            </Router>
        </div>
    )
    
}

export default ErrorFullApp;